import { useQuery } from "@tanstack/react-query";
import apiSetting from "../services/setting";

export function useBillSetting({ id_project, lang } = {}) {
  const bank_payment = useQuery({
    queryKey: ["bank_payment"],
    queryFn: () => apiSetting.BankPaymentSetting(),
    staleTime: 1000 * 60 * 5,
  });

  const creditBank = useQuery({
    queryKey: ["credit_bank", lang],
    queryFn: () => apiSetting.CreditBank({ lang }), 
    staleTime: 1000 * 60 * 5,
  });

  const project_detail = useQuery({
    queryKey: ["project_detail", id_project],
    queryFn: () => apiSetting.ProjectDetail({ id_project }), 
    staleTime: 1000 * 60 * 5,
  });

  const NameTitle = useQuery({
    queryKey: ["name_title"],
    queryFn: () => apiSetting.NameTitle(), 
    staleTime: 1000 * 60 * 5,
  });

  const WithHoldingTax = useQuery({
    queryKey: ["with_holding_tax"],
    queryFn: () => apiSetting.WithHoldingTax(), 
    staleTime: 1000 * 60 * 5,
  });
  
  const province = useQuery({
    queryKey: ["province", lang],
    queryFn: () => apiSetting.provinceAddressOption({ lang }), 
    enabled: !!lang,
    staleTime: 1000 * 60 * 5,
  });
  
  const district = useQuery({
    queryKey: ["district", lang],
    queryFn: () => apiSetting.districtAddressOption({ lang }), 
    enabled: !!lang,
    staleTime: 1000 * 60 * 5,
  });
  
  const subDistrict = useQuery({
    queryKey: ["sub_district", lang],
    queryFn: () => apiSetting.subDistrictAddressOption({ lang }), 
    enabled: !!lang,
    staleTime: 1000 * 60 * 5,
  });

  return { bank_payment,creditBank , project_detail, NameTitle, WithHoldingTax, province, district, subDistrict };
}
